import React, { Component } from 'react';
import moment from 'moment';

import TinyNodeSensorSettingsForm from './TinyNodeSensorSettingsForm';

import { defaultSorter, dateSorter } from './Helpers';
import TinyNodeSensorsModel from './TinyNodeSensorsModel';
import UserModel from './UserModel';

import { Table, Badge, Row, Col, Statistic, Popconfirm, Divider, message, Typography } from 'antd';

class TinyNodeSensorsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    tinyNodeSensorSettingsFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Napětí baterie [mV]"
              value={record.voltage} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Teplota [°C]"
              value={record.temp} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Uptime [h]"
              value={record.tBoot} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Bit status"
              value={record.parkingSensorBitStatus} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="Vector register"
              value={record.interruptVectorRegister} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="RSSI"
              value={record.interruptVectorRegister} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { return value; }}
              title="PPM"
              value={record.ppmMeasure} />
          </Col>
        </Row>
      </div >
    );
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lokalita',
      dataIndex: 'parkingLocationName',
      key: 'parkingLocationName',
      width: 270,
      sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName)
    }, {
      title: 'NodeID',
      dataIndex: 'nodeID',
      key: 'nodeID',
      width: 100,
      sorter: (a, b) => defaultSorter(a.nodeID, b.nodeID)
    }, {
      title: 'Místo',
      dataIndex: 'placeID',
      key: 'placeID',
      width: 75,
      defaultSortOrder: 'ascend',
      sorter: (a, b) => defaultSorter(a.placeID, b.placeID)
    }, {
      title: 'Poslední komunikace',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 185,
      sorter: (a, b) => dateSorter(a.updatedAt, b.updatedAt),
      render: (text, record) => {
        if (moment(record.updatedAt) <= moment().subtract(65, "minutes")) {
          return (
            <Badge
              status="error"
              text={moment(text).format('L LTS')}
              title="Poslední komunikace před více než 65 minutami" />
          );
        } else if (moment(record.updatedAt) <= moment().subtract(35, "minutes")) {
          return (
            <Badge
              status="warning"
              text={moment(text).format('L LTS')}
              title="Poslední komunikace před více než 35 minutami" />
          );
        } else {
          return (
            <Badge
              status="success"
              text={moment(text).format('L LTS')}
              title="Vpořádku" />
          );
        }
      }
    }, {
      title: 'Poslední změna stavu',
      dataIndex: 'lastStateChange',
      key: 'lastStateChange',
      width: 185,
      sorter: (a, b) => dateSorter(a.lastStateChange, b.lastStateChange),
      render: (text, record) => {
        return moment(text).format('L LTS');
      }
    }, {
      title: 'Stav',
      dataIndex: 'occ',
      key: 'occ',
      width: 150,
      filters: [{
        text: 'OBSAZENO',
        value: 1,
      }, {
        text: 'VOLNO',
        value: 0,
      }],
      filteredValue: filteredInfo.occ || null,
      onFilter: (value, record) => { return (parseInt(record.occ) === parseInt(value)) ? true : false },
      sorter: (a, b) => defaultSorter(a.occ, b.occ),
      render: (text, record) => {
        if (record.occ === 1) {
          return (
            <Badge
              status="error"
              text={"OBSAZENO"}
              title="Obsazeno" />
          );
        } else {
          return (
            <Badge
              status="success"
              text={"VOLNO"}
              title="Volno" />
          );
        }
      }
    }, {
      title: 'Upozornění',
      dataIndex: 'reportsEnabled',
      key: 'reportsEnabled',
      width: 130,
      filters: [{
        text: 'ZAPNUTO',
        value: true,
      }, {
        text: 'VYPNUTO',
        value: false,
      }],
      filteredValue: filteredInfo.reportsEnabled || null,
      onFilter: (value, record) => { return ((record.reportsEnabled === value)) ? true : false },
      render: (text, record) => {
        if (record.reportsEnabled === true) {
          return (
            <Badge
              status="success"
              text="ZAPNUTO" />
          );
        } else {
          return (
            <Badge
              status="error"
              text="VYPNUTO"
              title="Vpořádku" />
          );
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 200,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'TINYNODE_SENSORS_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                this.setState({
                  tinyNodeSensorSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow
                  ? this.props.onRemoveRow(record.id)
                  : null;
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }];

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          onChange={this.handleChange}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          expandedRowRender={this.expandedRowRender.bind(this)}
          style={{ border: '0px' }} />
        <TinyNodeSensorSettingsForm
          type="modal"
          modalVisible={this.state.tinyNodeSensorSettingsFormData === null ? false : true}
          initialValues={this.state.tinyNodeSensorSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ tinyNodeSensorSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            let data = Object.assign({}, this.state.tinyNodeSensorSettingsFormData, values)
            TinyNodeSensorsModel.update(this.state.tinyNodeSensorSettingsFormData.id, data)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  tinyNodeSensorSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default TinyNodeSensorsTable;


// WEBPACK FOOTER //
// ./src/components/TinyNodeSensorsTable.js